import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import myOrderTab from "./myOrderTabReducer";
import unreadReducer from "../features/unreadSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    myOrderTab,
    unread: unreadReducer,
  },
});

export default store;
